interface IProductState {
    PRODUCT_BOM_BASE_REFRESH?: boolean
    PRODUCT_BOM_BULK_REFRESH?: boolean
}

const product = {
    state(): IProductState {
        return {
            PRODUCT_BOM_BASE_REFRESH: false,
            PRODUCT_BOM_BULK_REFRESH: false,
        }
    },
    mutations: {
        /* 更新bom下Base Test Report 数据 */
        PRODUCT_BOM_BASE_REFRESH: (state: IProductState, data: boolean) => {
            state.PRODUCT_BOM_BASE_REFRESH = data
        },
         /* 更新bom下Bulk Test Report 数据 */
        PRODUCT_BOM_BULK_REFRESH: (state: IProductState, data: boolean) => {
            state.PRODUCT_BOM_BULK_REFRESH = data
        },
    },
}

export default product
